import { ChebyshevCoefficients } from '@ootk/src/interpolator/ChebyshevCoefficients';
import { Seconds } from '@ootk/src/main';

export const sednaChebyshevCoeffs: ChebyshevCoefficients[] = [
  new ChebyshevCoefficients(
    631152000 as Seconds,
    788940000 as Seconds,
    new Float64Array([
      20358255830.895805, -299842289.17867434, -527371.22339509323, 7573.2967914581295, -8898.277379671732, 435.6503412246704, -512.39461911519368, 164.70672849019368,
      -157.64774328867594, -150.68771870930991, 507.64956448872886, 1.3938751220703125,
    ]),
    new Float64Array([
      19083284149.858265, 113999468.94946118, -747706.17486546829, 45425.176080449419, 585.00966402689619, -615.11806519826257, 93.628265380859375, -6.8265097300211588,
      115.68700612386067, 83.912250773111978, -151.47935810089112, -75.324418131510413,
    ]),
    new Float64Array([
      2109663251.4955211, 65073668.618711159, -97079.293223468456, 20467.239298137029, 611.61739584207533, -378.5897517442703, 67.052393090724948, -169.7567797780037,
      -68.072788178920746, 205.73597950537999, -50.962038036187487, -166.04997320572534,
    ])
  ),
  new ChebyshevCoefficients(
    788940000 as Seconds,
    946728000 as Seconds,
    new Float64Array([
      19148444532.938557, -305481777.34402591, -1001671.8172051111, -50497.295848401387, 6787.1720703125002, 2213.9080698013304, -551.30009072621658, 19.251193110148112,
      -323.76988938649492, -152.05217202504477, 600.72702185312903, 61.954115358988446,
    ]),
    new Float64Array([
      19529576765.794308, 109286089.3356254, -603149.22472661338, -50525.680169041952, -9487.2276236216221, 920.76003996531165, 120.9526793162028, 139.66961784362792,
      -16.073626581827799, -18.114012908935546, 132.6882230122884, -72.55239276885986,
    ]),
    new Float64Array([
      2369490862.5449939, 64919956.548715472, -11987.931256405513, -19445.980288187664, -3959.0769795815149, 174.69719648361206, 182.71296433607736, -96.278049389521286,
      -269.33116403420763, 85.938725312550858, 108.70326393445333, 23.027002358436583,
    ])
  ),
  new ChebyshevCoefficients(
    946728000 as Seconds,
    1104516000 as Seconds,
    new Float64Array([
      17910832740.934818, -312999958.81091183, -653048.29840997059, 59871.890238698325, -7326.7502248128258, -885.95623601277669, -278.33016370137534, -109.6598388671875,
      -403.55682544708253, 127.81446107228597, 693.5802587509155, -32.357079442342119,
    ]),
    new Float64Array([
      19952732936.275482, 101835343.5687694, -1105551.2886376062, 22047.843947792055, 7998.4284209569296, -774.06649716695154, -29.679476165771483, -189.68596407572429,
      40.152735773722327, -69.541305605570471, 21.037430445353191, 87.376152674357101,
    ]),
    new Float64Array([
      2627175840.3759718, 63728155.693948135, -225099.3739264647, 8739.6929137309398, 3888.722245756785, -333.01661262512209, 116.83741398652394, -6.300217612584432,
      -193.96752968629201, -84.133927170435584, 110.49574343363444, 65.649138943354288,
    ])
  ),
  new ChebyshevCoefficients(
    1104516000 as Seconds,
    1262304000 as Seconds,
    new Float64Array([
      16649989257.455793, -317438155.6930871, -668023.27307027183, -55978.152067057294, -4975.8076860427855, 689.31731405258176, -315.47767483393352, 28.811797459920246,
      -323.19742352167765, 70.753181362152105, 555.49977534612015, -31.454287656148274,
    ]),
    new Float64Array([
      20345227552.505054, 94793425.813649431, -676809.563567098, 10982.208088556925, -8235.1089167277023, -765.90819015502927, 304.54329617818195, -34.824253145853675,
      64.370155016581222, 14.366624196370443, -218.8328820546468, 28.64350700378418,
    ]),
    new Float64Array([
      2879727423.1346364, 62719655.040867411, -31076.698081795374, 6782.0006346066793, -3258.5623032967251, -282.91809039910635, 218.91590367158253, 178.00076819260914,
      -169.04842416445413, -153.30234085718791, -4.5008535385131836, 89.781786799430847,
    ])
  ),
  new ChebyshevCoefficients(
    1262304000 as Seconds,
    1420092000 as Seconds,
    new Float64Array([
      15366448243.981974, -324526117.70324391, -867534.01755266183, 61792.060102589923, 5471.1573672294617, -2465.2046266237894, -865.79425678253176, 147.48818321228026,
      -257.95695292154949, -3.9567296028137204, 612.84394753774006, 25.038801924387613,
    ]),
    new Float64Array([
      20711288275.99752, 87770150.887286633, -1189610.2505037943, -37846.380558522542, 11260.141689745586, 568.58819115956624, -206.45541801452637, -72.501276969909668,
      -94.849995485941562, 181.70529015858969, -56.474156188964841, -149.0636043548584,
    ]),
    new Float64Array([
      3129269217.5630317, 61863815.776984155, -236079.4169812123, -16986.540744622547, 4547.2863774776461, 370.86506858666735, -78.153511261939997, 207.36549733479816,
      0.078402654329935706, -118.60223814646403, 28.128507121404013, 46.560793860753378,
    ])
  ),
  new ChebyshevCoefficients(
    1420092000 as Seconds,
    1577880000 as Seconds,
    new Float64Array([
      14058379302.944876, -329149929.69021833, -458302.93323993683, -22106.058220736184, -7915.4961784998577, 122.70085045496623, -980.96670544942219, -292.44021244049071,
      -269.43949162165325, 155.37085192998251, 757.33659868240352, 76.497183863321936,
    ]),
    new Float64Array([
      21043882714.885155, 78782324.115351617, -917340.23052539828, 41227.549316533405, -2893.6737530390419, -929.06178963979085, -57.559670766194664, 25.362740898132323,
      -66.875839042663571, 32.621572176615395, 140.61130746205649, 20.967746416727703,
    ]),
    new Float64Array([
      3373155212.6408463, 60187964.286260232, -119114.85952764352, 18964.627036658923, -1344.455279493332, -164.75253013769785, -45.757113130887348, 271.29842908382415,
      145.33207903703052, -143.10923324426014, -14.2664475440979, -69.017333205540979,
    ])
  ),
  new ChebyshevCoefficients(
    1577880000 as Seconds,
    1735668000 as Seconds,
    new Float64Array([
      12731081487.902761, -334975520.57457083, -982655.76110143657, -4945.8072896639505, 13465.599951394399, 502.4670225461324, -1187.1855852127076, -144.4677944501241,
      -136.53457091649372, 88.050829792022711, 536.80422805150351, 22.639822673797607,
    ]),
    new Float64Array([
      21345056406.859272, 71670459.295006558, -1084313.8102348964, -73699.319360669455, -1419.6414885203044, 2180.6269494374592, 129.77192064921061, -158.71320203145345,
      -100.7387186686198, -56.180936749776201, 23.434856669108072, 96.150044886271161,
    ]),
    new Float64Array([
      3612459650.9997845, 59426365.490562625, -168043.12116110325, -30770.690403739613, -1218.3091581741969, 976.84153293768566, -42.816788800557454, -34.039272085825601,
      166.54807745615642, -28.018550666173297, -133.25609683990479, 25.689735992749533,
    ])
  ),
  new ChebyshevCoefficients(
    1735668000 as Seconds,
    1893456000 as Seconds,
    new Float64Array([
      11378541644.152733, -340774826.91832972, -415971.72771733603, 29387.173647403717, -8956.2898478190109, 368.28993975321453, -807.38050394058223, -39.31122376124064,
      -13.513256200154622, -99.686842505137122, 540.96298586527507, 64.363019561767572,
    ]),
    new Float64Array([
      21611087225.240124, 61156277.20819696, -1309284.5308900196, 40468.456177520755, 2837.4744832992556, -949.08308022816971, 126.85974458058675, 203.36888211568197,
      -11.354070727030436, -123.83459841410318, -125.62745469411215, 45.030380121866862,
    ]),
    new Float64Array([
      3846047285.3457837, 57281555.962399855, -269326.41446318629, 17425.724827027319, 1245.8787673870722, -483.62514447371166, -60.000757972399391, -82.219742123285926,
      231.58971152305602, 71.204994233449298, -165.20007516543069, -8.5427690029144294,
    ])
  ),
  new ChebyshevCoefficients(
    1893456000 as Seconds,
    2051244000 as Seconds,
    new Float64Array([
      10008252154.785921, -344627074.85158956, -706393.35734275181, -53625.014521217345, 2379.7471324920652, 2149.5224349657692, -709.53970066706336, -152.62436463038125,
      -325.32738393147787, -76.564886411031083, 771.33689870834348, 144.32212864557903,
    ]),
    new Float64Array([
      21837375260.921997, 52226818.593362808, -1047990.2427494049, -30330.402872594197, -9975.1279898325593, 198.77720127105712, 215.48946723937988, 90.935363578796384,
      48.740924390157062, 30.382630856831867, -32.646240234375, -102.28112436930338,
    ]),
    new Float64Array([
      4072046000.0739536, 55832731.706781298, -142968.56406725248, -10969.407762463887, -4364.0974017063772, -48.92283570766449, -13.766842015584309, -219.8325956106186,
      81.987557840347293, 159.74237763881683, -84.727796236673996, -76.65118623574574,
    ])
  ),
  new ChebyshevCoefficients(
    2051244000 as Seconds,
    2209032000 as Seconds,
    new Float64Array([
      8617895972.8254089, -350329059.01319832, -458746.39022022882, 71577.556328201288, -4952.3202759424848, -1433.059793885549, -424.78386557896931, 76.222146224975589,
      -428.29829867680866, 7.3426513036092125, 756.85302785237627, -46.548788515726727,
    ]),
    new Float64Array([
      22025572839.048161, 41378363.813796803, -1584012.1941224416, 8160.5195063273113, 10370.732142893474, -744.8958337783813, -246.26223786671957, 256.6160320917765,
      -28.140616416931152, -153.75306383768717, 56.499244435628256, 14.096134312947591,
    ]),
    new Float64Array([
      4291442756.7010436, 53653180.951485731, -373823.39464584988, 2186.7762928088505, 4663.164966328939, -505.38392581144967, -109.05610664685567, -240.5817012310028,
      -86.518166963259375, 144.97145066261291, 75.239796217282617, 84.061938675244647,
    ])
  ),
  new ChebyshevCoefficients(
    2209032000 as Seconds,
    2366820000 as Seconds,
    new Float64Array([
      7212005440.0906124, -352480060.07427055, -295403.4049551487, -45490.847442642844, -6769.0751036485035, 499.09757447242737, -643.93236668904626, 50.354394356409706,
      -280.01003324190776, -56.198914893468221, 727.81267345746357, 102.13651035626729,
    ]),
    new Float64Array([
      22168328065.572472, 30397651.988324545, -1137058.6373903274, 24877.510327084859, -6708.4575058619184, -515.18522071838379, 67.778172238667807, -96.683491198221844,
      63.393319829305014, -114.81393025716146, -75.601066144307453, 158.77413628896076,
    ]),
    new Float64Array([
      4501136442.7782345, 51364455.73235175, -182685.92058313687, 12065.265603113174, -2479.118767595291, -238.54700504938762, 64.133319425582883, -105.75620738665263,
      -121.54321084022521, 19.257265106836954, 102.38754556179046, -11.303941909472147,
    ])
  ),
  new ChebyshevCoefficients(
    2366820000 as Seconds,
    2493072000 as Seconds,
    new Float64Array([
      5936966487.08354, -285134549.24454951, -430724.5543622335, 16583.319325478871, 4819.2315675576529, -411.34616839090984, -1086.7741863091787, 94.070340140660605,
      311.60378168423972, 42.857901922861735, 1225.3523065249126, -42.024411964416501,
    ]),
    new Float64Array([
      22263249884.397079, 17259672.427656174, -960277.61442642205, -35766.59934425354, 2276.8786914825441, 817.77364247639969, -13.780765088399251, -141.8602736790975,
      -113.65352554321289, 26.862555440266927, 21.036639149983724, -1.3419589360555013,
    ]),
    new Float64Array([
      4683638131.016777, 39866857.002949618, -209316.23784877459, -15903.437417904535, 854.42726186116533, 136.36385798454285, -188.25881231625874, 188.23999835650125,
      19.879287544886271, -91.334222857157386, 28.492354393005371, 24.260064061482748,
    ])
  ),
];
